import { render } from "./raw_materials.vue?vue&type=template&id=2f86bb1a"
import script from "./raw_materials.vue?vue&type=script&lang=js"
export * from "./raw_materials.vue?vue&type=script&lang=js"

import "./raw_materials.vue?vue&type=style&index=0&id=2f86bb1a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__